import React, { useMemo } from "react";
import { Button, Menu } from 'antd';
import {
  CloseOutlined,
  MenuOutlined,
  CalendarOutlined,
  ClusterOutlined,
  ControlOutlined,
  LockOutlined,
  UserOutlined,
  TeamOutlined,
  DatabaseOutlined,
  HomeOutlined,
  ApartmentOutlined,
  ThunderboltOutlined,
  MessageOutlined,
  BarChartOutlined,
  OrderedListOutlined,
  MailOutlined,
  RiseOutlined,
} from '@ant-design/icons';
import styles from "./style.module.scss";
import { useTranslation } from 'react-i18next';
import { resolveVisibleSettingsSidebarKeys } from "util/settingsSidebarVisibility";
import { resolveSettingsHomeNav } from "util/settingsHomeNav";

const ButtonStyle = (collapse) => ({
  // left: collapse ? "0px" : "185px",
})

const MenuStyle = (collapse, mobileView) => ({
  display: "block",
  width: "100%",
  borderInlineEnd: "none",
  transition: "all 0.3s ease-in",
})

const Representation = ({
  toggleCollapsed,
  mobileView,
  collapse,
  isAdmin,
  canManageTeams = false,
  isEnterprisePowerUser = false,
  plan,
  subscriptionRow = null,
  user = null,
  options,
  selected,
  onChange,
  ...props
}) => {
  const { t } = useTranslation();
  const visible = useMemo(
    () =>
      new Set(
        resolveVisibleSettingsSidebarKeys({
          plan,
          isAdmin,
          canManageTeams,
          isEnterprisePowerUser,
          subscriptionRow,
        }),
      ),
    [plan, isAdmin, canManageTeams, isEnterprisePowerUser, subscriptionRow],
  );

  const homeNav = useMemo(
    () => resolveSettingsHomeNav({ user, subscriptionRow, t }),
    [user, subscriptionRow, t],
  );

  const getSettingsHref = (key) =>
    key === "home" ? homeNav.href : `/settings/${key}`;

  const renderNavLinkItem = (key, icon, label) => {
    if (!visible.has(key)) return null;
    return (
      <Menu.Item key={key} icon={icon}>
        <a
          className={styles.hyperLink}
          href={getSettingsHref(key)}
          onClick={(e) => e.preventDefault()}
        >
          {label}
        </a>
      </Menu.Item>
    );
  };

  const themeClass =
    props.theme === "light"
      ? styles.wrapperLight
      : props.theme === "brand"
      ? styles.wrapperBrand
      : styles.wrapperDark;

  const layoutClass = collapse
    ? styles.wrapperCollapsed
    : mobileView
    ? styles.wrapperMobile
    : "";

  return (
    <div className={`${styles.wrapper} ${themeClass} ${layoutClass}`}>
      <Menu
        onClick={(elem) => onChange(elem.key)}
        defaultSelectedKeys={[selected || "details"]}
        mode="inline"
        theme="dark"
        style={MenuStyle(collapse, mobileView)}
        className={`${styles.settingsMenu} ${props.theme === 'dark' ? "" : props.theme === 'light' ? "setting-light-sidebar" : "setting-brand-sidebar"}`}
      >
        {renderNavLinkItem("home", <HomeOutlined />, homeNav.label)}
        {renderNavLinkItem("details", <UserOutlined />, t("settings_sidebar.1"))}
        {renderNavLinkItem("security", <LockOutlined />, t("settings_sidebar.2"))}
        {renderNavLinkItem("preferences", <ControlOutlined />, t("settings_sidebar.3"))}
        {renderNavLinkItem("integrations", <ClusterOutlined />, t("settings_sidebar.4"))}
        {renderNavLinkItem("plan", <CalendarOutlined />, t("settings_sidebar.5"))}
        {renderNavLinkItem("teams", <DatabaseOutlined />, t("settings_sidebar.6"))}
        {renderNavLinkItem("users", <TeamOutlined />, t("settings_sidebar.7"))}
        {renderNavLinkItem("advisor-history", <MessageOutlined />, t("settings_sidebar.12"))}
        {renderNavLinkItem("genai-queue", <OrderedListOutlined />, t("settings_sidebar.14"))}
        {renderNavLinkItem("engagement", <BarChartOutlined />, t("settings_sidebar.13"))}
        {renderNavLinkItem("email-reports", <MailOutlined />, t("settings_sidebar.15"))}
        {renderNavLinkItem("market-intelligence-preview", <RiseOutlined />, t("settings_sidebar.16"))}
        {renderNavLinkItem("ai-credits", <ThunderboltOutlined />, t("settings_sidebar.11"))}
        {renderNavLinkItem("topic-library", <ApartmentOutlined />, t("settings_sidebar.10"))}
      </Menu>
      <Button className={styles.collapseBtn} style={ButtonStyle(collapse)} onClick={toggleCollapsed}>
        {collapse ? <MenuOutlined /> : <CloseOutlined />}
      </Button>
    </div>
  )
}

export default Representation;
